const OliviaFooter = require("./OliviaFooter.png");

export { OliviaFooter };
